import { jsx as r } from "../../_virtual/jsx-runtime.mjs";
import { inputInfo as e } from "./css/ReoInput.mjs";
import a from "../../depend/classnames/index.mjs";
const t = (n) => n.children ? /* @__PURE__ */ r(
  "span",
  {
    className: a(e, n.className),
    children: n.children
  }
) : null;
export {
  t as default
};
//# sourceMappingURL=Info.mjs.map
